import React, { useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DeviantArtLogo from '@wix/da-ds/pkg/Icons/DeviantArtLogo';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BannerLayout, BannerMessage, BannerButton } from '@wix/da-ds/pkg/Banner/lego';
import CloseIcon from '@wix/da-ds/pkg/Icons/16x16/Close';
import { usePWAInstallBanner } from './usePWAInstallBanner';
import { isiOS } from '../utils/browser';
import s from './PWAInstallBanner.scss';
const PWAInstallBanner = ()=>{
    const { t } = useTranslation();
    const { dismiss, isHidden, onInstall } = usePWAInstallBanner();
    const [isExpanded, setIsExpanded] = useState(false);
    if (isHidden) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(BannerLayout, {
        size: isExpanded ? 'multiline' : 'big',
        className: c(s['root'], isExpanded && s['expanded']),
        bodyClassName: s['body'],
        body: [
            isExpanded && /*#__PURE__*/ React.createElement("div", {
                className: s['logo']
            }, /*#__PURE__*/ React.createElement(DeviantArtLogo, {
                size: IconSize.LARGE,
                disableDefaultColors: true
            })),
            !isExpanded && /*#__PURE__*/ React.createElement(IconButton, {
                icon: CloseIcon,
                "aria-label": t('common.close'),
                key: "midfix-icon",
                size: "small",
                iconClassName: s['icon'],
                onClick: dismiss
            }),
            /*#__PURE__*/ React.createElement(BannerMessage, {
                key: "message-after-icon",
                weight: "bld",
                className: s['your-typography-colors']
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['title']
            }, t('pwa.install.banner.title')), !isExpanded && /*#__PURE__*/ React.createElement("div", {
                className: s['subtitle']
            }, t('pwa.install.banner.subtitle')), isExpanded && isiOS() && /*#__PURE__*/ React.createElement("div", {
                className: s['subtitle']
            }, t('pwa.install.banner.iPhoneInstructions', {
                postProcess: [
                    'reactPostprocessor',
                    'featureBrancher'
                ],
                icon: /*#__PURE__*/ React.createElement("img", {
                    src: "https://st.deviantart.net/eclipse/icons/pwa/ios-share.svg",
                    className: s['share-icon'],
                    alt: "Share"
                })
            }))),
            isExpanded && /*#__PURE__*/ React.createElement(TextButton, {
                size: "large",
                type: "button",
                variant: "main",
                priority: "primary",
                onClick: ()=>setIsExpanded(false)
            }, t('pwa.install.banner.close'))
        ],
        postfix: !isExpanded && /*#__PURE__*/ React.createElement(BannerButton, {
            variant: "solid",
            onClick: ()=>isiOS() ? setIsExpanded(true) : onInstall()
        }, t('pwa.install.banner.cta'))
    });
};
PWAInstallBanner.displayName = 'PWAInstallBanner';
export default PWAInstallBanner;

//# sourceMappingURL=PWAInstallBanner.js.map